/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ContactFromJSON(json) {
    return ContactFromJSONTyped(json, false);
}
export function ContactFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'contactId': !exists(json, 'contactId') ? undefined : json['contactId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'departmentCode': !exists(json, 'departmentCode') ? undefined : json['departmentCode'],
        'departmentName': !exists(json, 'departmentName') ? undefined : json['departmentName'],
        'tenantName': !exists(json, 'tenantName') ? undefined : json['tenantName'],
        'campus': !exists(json, 'campus') ? undefined : json['campus'],
        'location1': !exists(json, 'location1') ? undefined : json['location1'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'location2': !exists(json, 'location2') ? undefined : json['location2'],
        'location3': !exists(json, 'location3') ? undefined : json['location3'],
        'contactActiveFlag': !exists(json, 'contactActiveFlag') ? undefined : json['contactActiveFlag'],
    };
}
export function ContactToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'contactId': value.contactId,
        'propertyId': value.propertyId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'emailAddress': value.emailAddress,
        'phone': value.phone,
        'company': value.company,
        'departmentCode': value.departmentCode,
        'departmentName': value.departmentName,
        'tenantName': value.tenantName,
        'campus': value.campus,
        'location1': value.location1,
        'floor': value.floor,
        'location2': value.location2,
        'location3': value.location3,
        'contactActiveFlag': value.contactActiveFlag,
    };
}
